module.exports = __webpack_public_path__ + "static/media/image8.19c8588f.png";